export enum TransporterEnum {
  GEODIS = 0,
  DPD = 1,
  SCHENKER = 2,
  KUEHNE = 3,
  TNT = 4,
  CHRONOPOST = 5,
  HEPPNER = 6,
  DHL = 7,
  EXTERNAL = 96,
  CHARTER = 97,
  PICKUP = 98,
  COURIER = 99,
  UNKNOWN = -1,
}
